import Typography from "../../Utility/Typography";

/**
 * Summary row above time entry tables (date range + hour totals).
 */
export default function TimeEntryTableTotalsBar({
  dateRangeLabel = "",
  /** Logged hours total (timesheet tables). */
  loggedLabel = "",
  /** Billable hours total (timesheet tables). */
  billableLabel = "",
  /** Legacy single total (team/project summary, work log section). */
  totalLabel = "",
  className = "",
}) {
  const showLoggedBillable = Boolean(loggedLabel || billableLabel);

  return (
    <div
      className={`flex flex-wrap justify-between items-center gap-3 py-2 text-sm font-semibold ${className}`.trim()}
    >
      {dateRangeLabel ? (
        <Typography variant="span">
          <strong>{dateRangeLabel}</strong>
        </Typography>
      ) : (
        <span />
      )}
      {showLoggedBillable ? (
        <div className="flex flex-wrap items-center gap-4 sm:gap-6">
          {billableLabel ? (
            <Typography variant="span">
              Billable: <strong>{billableLabel}</strong>
            </Typography>
          ) : null}
          {loggedLabel ? (
            <Typography variant="span">
              Logged: <strong>{loggedLabel}</strong>
            </Typography>
          ) : null}
        </div>
      ) : totalLabel ? (
        <Typography variant="span">
          Total: <strong>{totalLabel}</strong>
        </Typography>
      ) : null}
    </div>
  );
}
